import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import Reveal from "./Reveal";
import { JasmineStrand, JasmineGarland, FloralLineArt } from "./Ornaments";

export default function Story() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-4%", "4%"]);

  return (
    <section id="story" className="story" data-testid="story-section" ref={ref}>
      <div className="story-frame" aria-hidden="true">
        <span className="fdot fdot-tl" />
        <span className="fdot fdot-tr" />
        <span className="fdot fdot-bl" />
        <span className="fdot fdot-br" />
      </div>
      <div className="story-orn story-strand">
        <JasmineStrand width={230} />
      </div>
      <div className="story-gar" style={{ left: "5%" }}>
        <JasmineGarland rows={12} dur={7.4} />
      </div>
      <div className="story-gar" style={{ right: "5%" }}>
        <JasmineGarland rows={9} delay={1.2} dur={8.2} />
      </div>
      <div className="story-fline fline-tr">
        <FloralLineArt width={190} />
      </div>
      <div className="story-fline fline-bl">
        <FloralLineArt width={190} />
      </div>

      <div className="story-copy">
        <Reveal>
          <h2>Our Story</h2>
          <p>
            From school friends to partners in life, ours has always been a
            story of growing together.
          </p>
          <p>
            Five years, countless little moments, and now, with our families
            beside us, we begin our forever.
          </p>
          <div className="story-rule" />
        </Reveal>
      </div>

      <div className="story-photo">
        <motion.img
          src="/images/story.webp"
          alt="Divyanshi and Divyashiv"
          style={{ y }}
        />
      </div>
    </section>
  );
}
